import { ColumnConfig } from '../hooks/useTablePreferences';

export const emailTemplateColumns: ColumnConfig[] = [
  {
    key: 'name',
    label: 'Name',
    defaultWidth: 180,
    minWidth: 150,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'internal_id',
    label: 'Internal ID',
    defaultWidth: 140,
    minWidth: 120,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'context',
    label: 'Context',
    defaultWidth: 120,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'subject',
    label: 'Subject',
    defaultWidth: 220,
    minWidth: 150,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'language',
    label: 'Language',
    defaultWidth: 100,
    minWidth: 80,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'status',
    label: 'Status',
    defaultWidth: 100,
    minWidth: 90,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'createdAt',
    label: 'Created',
    defaultWidth: 130,
    minWidth: 110,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
];
